// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"e33b3155","876":"a4321425"}[chunkId] + ".chunk.js";
};